<div class=content>
  <router-outlet></router-outlet>
  <app-footer *ngIf="!whiteLabel"></app-footer>
</div>
